<template>
    
            <v-dialog v-model="visFl" persistent width="auto" max-width="800" @keydown.esc="close" @keydown.enter="doAct">
              <v-card>
                <v-card-title class="headline">
                  {{ $t( 'message.add_assignment_title' ) }}
                </v-card-title>
                <v-card-text>
                          <v-form ref="form" v-model="valid" lazy-validation>

                            <v-select :label="$t( 'message.add_assignment_name' )" required item-text="ass_name" 
                               item-value="ass_urn" v-model="prop" return-object
                              :items="props" :rules="[v => !!v || $t( 'message.value_required' )]" @change="updateValues()">
                            </v-select>

                            <v-select :label="$t( 'message.add_assignment_val' )" v-if="prop.ass_type === 'CLASS'"
                                required v-model="oneVal" :rules="rules" no-data-text=""
                                :menu-props="{ closeOnContentClick: true }" hide-selected :items="valList" 
                                item-text="name" item-value="urn" >
                                <template v-slot:prepend-item>
                                    <v-treeview :items="items" style="font-size: 14px;" :active="treeActive"
                                        activatable item-key="urn" item-text="name" item-children="children" dense 
                                        transition @update:active="selectVal">
                                    </v-treeview>
                                </template>
                            </v-select>
                            <v-text-field v-else :label="$t( 'message.add_assignment_val' )" 
                                      required v-model="oneVal" :type="type" :rules="rules"></v-text-field>
                          </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                    <v-btn id="addAssignmentOk" color="green darken-1" text @click.native="doAct" :disabled="!valid">{{ $t( 'message.ok_btn' ) }}</v-btn>
                    <v-btn id="addAssignmentClose" color="green darken-1" text @click.native="close">{{ $t( 'message.cancel_btn' ) }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>   
<!--          </v-layout>
      </v-container>-->
    
</template>

<script>
    
import Vue from 'vue'
import{ conf } from '@/utils/confTruePLM';

export default {
  name: 'addAssignment',
  data () 
  {
    return {
        visFl: false,
        resolve: null,
        reject: null,
        prop: {},
        type: 'text',
        oneVal: null,
        valid: true,
        props: [], 
        items: [],
        treeActive: [],
        valList: [],
        rules: []
    };
  },
  computed: {
  },
  methods: {
      open( aList, curVal )
      {
          this.props = aList || [];

     //     this.items = valList;
          this.valid = true;

          // this.valList = [ { urn: curVal, name: this.$utils.clearType( curVal ) } ];
          // this.oneVal = this.valList[ 0 ];
          // this.treeActive = [ this.oneVal ];
          this.oneVal = null;

          this.visFl = true;

          return new Promise( ( resolve, reject ) => 
          {
            this.resolve = resolve;
            this.reject = reject;
          });
      },
      updateValues()
      {
          if( this.prop.ass_type !== 'CLASS' )
              return;

          let self = this;
          conf.getTypesTree( this.prop.role_urn )
              .then( data =>
          {
              self.items = data;
          })
              .catch( ( err ) =>
          {
              self.$eventBus.$emit( 'queryError', err );
          });
      },
      selectVal( elems )
      {
          if( elems && elems.length > 0 )
          {
              this.valList = [ { urn: elems[ 0 ], name: this.$utils.clearType( elems[ 0 ] ) } ];
              this.oneVal = elems[ 0 ];
          }
      },
      
      close()
      {
          this.visFl = false;
          this.reject();
      },
      doAct()
      {
          if( this.$refs.form.validate() )
          {
                this.visFl = false;
                this.resolve( { prop: this.prop, val: this.oneVal } );
          }
      }
    }
}
</script>



